'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';
import Why from '@/components/home-page/whySection';
import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';
import Image from "next/image";



const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/Consultants.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    Testing & Consulting
  </h1>
    
  </div>

  <NavBar />

  <section className="about-me-copy  bg-secondary">
          <div className="about-me-copy-wrapper">
            <h2 className='text-primary text-3xl lg:text-6xl py-8'>
              Great software isn't just shipped, it's verified. We test
              rigorously and advise strategically, so every decision you make
              is backed by evidence, not guesswork.
            </h2>

          </div>
        </section>

        <section className="services">
 <div className="services-col">
  <div className="services-banner">
    <Image
      src="/hero/testing.avif"
      alt=""
      fill
      style={{ objectFit: "cover" }}
      sizes="(max-width: 768px) 100vw, 50vw"
    />
  </div>
</div>
          <div className="services-col ">
            <h4 className='text-2xl lg:text-3xl'>
              Every engagement starts with understanding your product and
              your risks. We combine hands-on testing with strategic
              consulting to help you ship with confidence and grow with
              clarity.
            </h4>

            <div className="services-list">
              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Software Testing & QA</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We put your application through thorough functional,
                    performance, and regression testing, catching bugs and
                    bottlenecks before your users ever do.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Technical Consulting</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    From architecture planning to technology stack decisions,
                    we provide clear, experienced guidance so you build on
                    the right foundation from the start.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Audits & Strategy</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We audit your existing systems and processes, identify
                    risks and inefficiencies, and deliver a clear roadmap for
                    improvement and scale.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

<Why/>
<ContactForm/>

<FAQContainer
  title={"Testing &\nConsulting FAQs"}
  description="Answers to the most common questions clients ask about our testing process, consulting engagements, and how we work together."
  faq={[
    {
      question: "What types of testing do you offer?",
      answer:
        "We provide functional testing, performance testing, regression testing, and bug tracking to ensure your application is stable and reliable before and after launch.",
    },
    {
      question: "What does your technical consulting cover?",
      answer:
        "Our consulting includes technical audits, architecture planning, technology stack recommendations, and strategic guidance for your digital projects.",
    },
    {
      question: "Do I need an existing product for you to test it?",
      answer:
        "Yes, we test existing applications at any stage, whether pre-launch, post-launch, or ahead of a major release or migration.",
    },
    {
      question: "Can you audit a system another team built?",
      answer:
        "Absolutely. We regularly audit codebases and architecture built by other teams and provide a clear, honest assessment along with recommendations.",
    },
    {
      question: "How long does a consulting engagement take?",
      answer:
        "It depends on scope, but most audits and consulting engagements take 1–4 weeks, with ongoing advisory available if needed.",
    },
    {
      question: "Will I get a written report after testing or an audit?",
      answer:
        "Yes, every testing cycle and audit ends with a detailed report outlining findings, priorities, and clear next steps.",
    },
  ]}
/>
<Footer/>
</>
  );
};

export default ContactForms;